import { IconName } from '../..';
import { FareItem } from './Summary.model';

const iconMap: Record<FareItem['code'], IconName> = {
	CABINA: 'maleta-15kg',
	EQMANO: 'maleta-15kg',
	EQBODEGA: 'equipaje-10-14kg',
	ASIENTO: 'asiento',
	ASIENTOPREFERENTE: 'asiento-upgrade',
	ASIENTOXL: 'asiento-plus',
	ASIENTODELANTERO: 'asiento-delantero',
	CAMBIO: 'calendario',
	REEMBOLSO: 'calendario-reembolso',
	CHECKINDESK: 'validar',
	SALAVIP: 'sala-vip',
	FASTTRACK: 'fast-track',
	TARJEMBANTIC: 'passbook-tarjeta-embarque',
	EQPPRIOR: 'embarque-prioritario',
	COMIDA: 'bandeja-comida',
	EMBARQUE: 'embarque-prioritario',
	AVIO: 'avios-filled',
	WIFI: 'alerta'
};

export const getFareItemIcon = (code: keyof typeof iconMap): IconName | undefined => {
	return iconMap[code];
};
